import { render, staticRenderFns } from "./TagTableInactive.vue?vue&type=template&id=816bf942&scoped=true"
import script from "./TagTableInactive.vue?vue&type=script&lang=js"
export * from "./TagTableInactive.vue?vue&type=script&lang=js"
import style0 from "./TagTableInactive.vue?vue&type=style&index=0&id=816bf942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816bf942",
  null
  
)

export default component.exports